import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo-transparent.png";
import usePageMeta from "../hooks/usePageMeta";

function PrivacyPolicyPage() {
  usePageMeta({
    title: "Politique de confidentialité",
    description:
      "Consultez la politique de confidentialité du site portfolio de Sofiane Amroune.",
  });

  return (
    <div className="page-shell space-y-8 lg:space-y-10">
      <section className="hero-panel">
        <div className="grid items-center gap-8 lg:grid-cols-[1.2fr,0.8fr]">
          <div>
            <span className="eyebrow">Confidentialité</span>
            <h1>Politique de confidentialité</h1>
            <p className="mt-5 max-w-2xl text-lg leading-8 text-muted">
              Cette page explique quelles informations peuvent être collectées via le formulaire
              de contact, dans quel cadre elles sont utilisées et avec quelles garanties.
            </p>
          </div>
          <div className="flex justify-center lg:justify-end">
            <div className="flex h-40 w-40 items-center justify-center rounded-full border border-brand/20 bg-white/85 shadow-panel sm:h-48 sm:w-48">
              <img
                src={logo}
                alt="Logo Sofiane Amroune"
                className="h-28 w-28 object-contain sm:h-32 sm:w-32"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="legal-section">
        <h2 className="text-3xl">Introduction</h2>
        <p>
          La protection de vos données personnelles est une priorité. Les informations
          éventuellement recueillies via <strong>samroune.fr</strong> servent uniquement à
          répondre à votre demande.
        </p>
      </section>

      <section className="legal-section">
        <h2 className="text-3xl">Données collectées</h2>
        <p>
          Aucune donnée personnelle n’est collectée automatiquement lors de la navigation.
          Les seules informations susceptibles d’être transmises sont celles que vous saisissez
          volontairement dans le formulaire de contact :
        </p>
        <ul className="space-y-3">
          <li>Nom</li>
          <li>Adresse email</li>
          <li>Téléphone</li>
          <li>Message</li>
        </ul>
        <p>
          Ces données sont utilisées uniquement pour répondre à votre demande. Elles ne sont pas
          revendues et ne sont pas transmises à des tiers à des fins commerciales.
        </p>
      </section>

      <section className="legal-section">
        <h2 className="text-3xl">Cookies</h2>
        <p>
          Le site ne dépose pas de cookie de suivi à des fins marketing ou publicitaires.
          Aucune mesure d’audience nominative n’est réalisée.
        </p>
      </section>

      <section className="legal-section">
        <h2 className="text-3xl">Sécurité</h2>
        <p>
          Les données envoyées via le formulaire de contact sont traitées dans le seul but
          d’échanger avec vous. Elles ne sont pas exposées publiquement.
        </p>
      </section>

      <section className="legal-section">
        <h2 className="text-3xl">Vos droits</h2>
        <p>
          Conformément au RGPD, vous pouvez demander l’accès, la rectification ou la suppression
          de vos données personnelles.
        </p>
        <p>
          Pour exercer vos droits, utilisez la page{" "}
          <Link to="/mentions-legales" className="content-link">
            Mentions légales
          </Link>{" "}
          ou le formulaire disponible sur la page contact.
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicyPage;
